module.exports = __webpack_public_path__ + "static/media/no-calculator.37d784e3.svg";